import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getSettings = () => api.get("/settings").then((r) => r.data);
export const getStats = () => api.get("/stats").then((r) => r.data);
export const getServices = () => api.get("/services").then((r) => r.data);
export const getService = (slug) => api.get(`/services/${slug}`).then((r) => r.data);
export const getIndustries = () => api.get("/industries").then((r) => r.data);
export const getIndustry = (slug) => api.get(`/industries/${slug}`).then((r) => r.data);
export const getCompliance = () => api.get("/compliance").then((r) => r.data);
export const getComplianceItem = (slug) => api.get(`/compliance/${slug}`).then((r) => r.data);
export const getWhyChooseUs = () => api.get("/why-choose-us").then((r) => r.data);
export const getValues = () => api.get("/values").then((r) => r.data);
export const getApproach = () => api.get("/approach").then((r) => r.data);
export const getFaqs = () => api.get("/faqs").then((r) => r.data);
export const getPage = (slug) => api.get(`/pages/${slug}`).then((r) => r.data);
export const getNews = () => api.get("/news").then((r) => r.data);
export const getPublications = () => api.get("/publications").then((r) => r.data);
export const getGallery = () => api.get("/gallery").then((r) => r.data);
export const mediaUrl = (id) => (id ? `${API}/media/${id}` : "");
export const postContact = (payload) => api.post("/contact", payload).then((r) => r.data);
